import { render, staticRenderFns } from "./c_player_teacherinfo.vue?vue&type=template&id=77fb5b63&scoped=true&"
import script from "./c_player_teacherinfo.vue?vue&type=script&lang=js&"
export * from "./c_player_teacherinfo.vue?vue&type=script&lang=js&"
import style0 from "./c_player_teacherinfo.vue?vue&type=style&index=0&id=77fb5b63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb5b63",
  null
  
)

export default component.exports